import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Alert from '../components/Alert';
import api from '../services/api';
import '../styles/Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/auth/forgot-password', { email });
      console.log('✅ Password reset email sent:', response.data);
      setMessage(`Password reset link has been sent to ${email}. Check your email inbox.`);
      setSubmitted(true);
      setEmail('');
    } catch (err) {
      console.error('❌ Forgot password error:', err);
      setError(err.response?.data?.detail || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>🏭 IndustrialIQ</h1>
            <p>AI-Powered Document Intelligence</p>
          </div>

          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <h2 style={{ marginBottom: '20px' }}>Check Your Email</h2>
            <Alert type="success" message={message} />
            <p style={{ marginTop: '20px', color: '#666' }}>
              We've sent you a password reset link. Click the link in your email to reset your password.
            </p>
            <p style={{ marginTop: '30px', fontSize: '14px', color: '#999' }}>
              Didn't receive an email? Check your spam folder or{' '}
              <button
                type="button"
                onClick={() => setSubmitted(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#0B3D91',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                try again
              </button>
            </p>
            <Link to="/login" style={{ display: 'block', marginTop: '30px', color: '#0B3D91' }}>
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>🏭 IndustrialIQ</h1>
          <p>AI-Powered Document Intelligence</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Reset Your Password</h2>
          <p style={{ color: '#666', marginBottom: '20px', fontSize: '14px' }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>

          {error && (
            <Alert
              type="error"
              message={error}
              onClose={() => setError('')}
            />
          )}

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>

          <p className="auth-link">
            Remember your password? <Link to="/login">Log in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
